import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, Input, Self } from '@angular/core';
import { CmsArea } from '@domgen/dgx-fe-cms';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';

import { SectionLoadingDirective } from '@domgen/dgx-fe-components/loading';
import { RegistrationWarrantyNotePanelComponent } from '@us-registration/feature-components';
import {
  RegistrationConfirmationApplianceDetailsPanelComponent,
  RegistrationConfirmationCPGPanelComponent,
} from '@us-registration/ui-components';
import { RegistrationConfirmationComponentService } from '../../services/registration-confirmation-component.service';

@Component({
  selector: 'us-registration-registration-confirmation',
  standalone: true,
  imports: [
    AsyncPipe,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgFor,
    NgIf,
    RegistrationConfirmationApplianceDetailsPanelComponent,
    RegistrationConfirmationCPGPanelComponent,
    RegistrationWarrantyNotePanelComponent,
    SectionLoadingDirective,
  ],
  providers: [RegistrationConfirmationComponentService],
  templateUrl: './registration-confirmation.component.html',
  styleUrls: ['./registration-confirmation.component.scss'],
})
export class RegistrationConfirmationComponent {
  @Input() main!: CmsArea;

  constructor(@Self() readonly cs: RegistrationConfirmationComponentService) {}
}
